import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnComplete,
} from "@insite/client-framework/HandlerCreator";
import { GetSessionApiParameter, Session } from "@insite/client-framework/Services/SessionService";
import { getCurrentSession } from "@SupplyLand/Services/SupplyLandInactivityService";

type HandlerType = ApiHandlerDiscreteParameter<
    GetSessionApiParameter & HasOnComplete<{ apiResult: Session }> & { isSessionUpdate?: true },
    GetSessionApiParameter,
    Session
>;

export const GetCurrentSession: HandlerType = async props => {
    props.apiResult = await getCurrentSession();
};

export const chain = [GetCurrentSession];

const resetServerSideInactivity = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetServerSideInactivity");
export default resetServerSideInactivity;
